import { CustomCountdown } from "./CustomCountdown";

export const MobileCountdown = ({ total, days, hours, minutes, seconds }) => {
    return (
        <CustomCountdown xs={true} days={days} hours={hours} minutes={minutes} seconds={seconds} />
    )
}